/** CSV the way Turkish Excel opens it: UTF-8 with BOM, semicolons, decimal commas left to the caller. */
export function downloadCsv(filename: string, rows: readonly (readonly (string | number | null)[])[]): void {
  const cell = (value: string | number | null) => {
    const text = value === null ? '' : String(value);
    return /[";\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
  };
  const body = rows.map((r) => r.map(cell).join(';')).join('\r\n');
  const blob = new Blob(['﻿', body], { type: 'text/csv;charset=utf-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  setTimeout(() => URL.revokeObjectURL(link.href), 10_000);
}

/** "123.45" → "123,45" for spreadsheets set to Turkish */
export const csvDecimal = (value: string | number | null) => (value === null ? '' : String(value).replace('.', ','));
